import React from 'react'
import ACom1 from '../../Images/HR/AccountComittee/LubrajAcharya.jpg'
import ACom2 from '../../Images/HR/AccountComittee/SabitraSiwakotiBaruwal.jpg'
import ACom3 from '../../Images/HR/AccountComittee/BirBahadurPithakoteMagar.JPG'
import Aos from 'aos'

const AccountComittee = () => {

    Aos.init({
        duration: 1500,
        once: false,
        mirror: false,
        easing: 'ease-in-out-sine'
    });

    const ComitteeList = [
        {
            id: '1',
            memName: 'लुवराज आचार्य',
            post: 'संयोजक',
            memImg: ACom1
        },
        {
            id: '2',
            memName: 'सावित्रा सिवाकोटी बरुवाल',
            post: 'सदस्य',
            memImg: ACom2
        },
        {
            id: '3',
            memName: 'वीरबहादुर पीठाकोटे मगर',
            post: 'सदस्य',
            memImg: ACom3
        }
    ]

    return (
        <>
            <div className='main'>
                <div className='left-fixed'></div>
                <div className='container'>
                    <div className='heading1' data-aos='fade-right'>
                        <div className='h2'>
                            <h2>कनकलक्ष्मी साकोस :: लेखा सुपरिवेक्षण समिति</h2><hr />
                        </div>
                    </div>
                    <div className='president2' data-aos='fade-right'>
                        {ComitteeList.map((item, index) => {
                            return (
                                <div className='president2-body' key={index}>
                                    <div className='president2-img'>
                                        <img src={item.memImg} alt='AccountComittee' />
                                    </div>
                                    <div className='president2-detail'>
                                        <h2>{item.memName}</h2>
                                        <h3>{item.post}</h3>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
                <div className='right-fixed'></div>
            </div>
        </>
    )
}

export default AccountComittee